var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMenu = function SvgMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 20,
    fill: "#DAC599",
    viewBox: "0 0 28 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h28v2H0zM0 9h28v2H0zM0 18h28v2H0z"
  })));
};
export default SvgMenu;